import { Injectable } from "@angular/core";
import { ID } from "@common/interfaces/id";
import { IID_EP_RICHIESTA_PERMESSO } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, StoreConfig, EntityStore } from "@datorama/akita";

export interface IIDEpRichiestaState extends EntityState<IID_EP_RICHIESTA_PERMESSO, ID> { }

@Injectable({
  providedIn: 'root'
})
@StoreConfig({ name: Topics.IID_EP_RICHIESTA_PERMESSO })
export class IIDEpRichiestaStore extends EntityStore<IIDEpRichiestaState> {
  constructor() {
    super([]);
  }
}